

/*
	Expressions are converted to reflect the full path before this function is called,
	The component path is also a full path.
	Locations are matched start-to-end. In regex terms: /^XXX$/.

	Currently supported syntax:
	['vertical 0',..,]		- a path through a component tree
	*						- one mandatory component (any name)
	**						- zero to many components
	^						- match top of the page
	'text:title'			- component with class filter
	'* foreground'			- any component with childKey 'foreground' (compound: name + childKey filter)
	'overlay foreground'	- overlay with childKey 'foreground'
	'*:class 0'				- class filter and childKey filter combined
	'* *'					- any component with any childKey

	{location:['a','**','c'], matchChildren:false }	- return matches after a parent match has already been found
	{location:['a','**','c'], matchChildren:true }	- just return the one match on a branch

	Allow locations in themes to be nested - eg:
		styles: {
			'Test style': [{
				location: ['*'],
				css: {
					backgroundColor: '#b2b23375'
				},
				children: [{
					location: ['text:title'],
					css: {
						color: '#5cd5ff'
					}
				}]
			}]
		}

	ALTERNATIVE/SUPPLEMENTARY SYNTAXES AND APPROACHES
	1. CSS 
	2. JSONPath (see all the filters)
	3. solid.js set store path 
	4. Bash regex matching... + other regexs

	Note that using "location-style" matching rather than CSS has the advantage of 
	being simpler to implement and use and the big advantage of removing the need to use classes. 
	Additionally locations also allow us to change the HTML to render, not just the CSS.
*/

import { PathElement } from 'Shared/frontend/widgets/StylesProvider';

export function locationMatches(expression:(string|number)[],path:PathElement[])
{
	let i=0, j=0;

	while (true) {
		if (i == expression.length && j == path.length) 
			return true;
		else if (expression[i] == '**') 
			return someTailMatches(expression.slice(i+1),path,j);
		else if (i == expression.length || j == path.length)
			return false;
		else if (expressionMatches(expression[i],path[j])) {
			i++;
			j++;
		}
		else
			return false;
	}
}

/* There's likely to be a more efficient algorithm for this */
function someTailMatches(expressionTail:string[],path:PathElement[],j:number)
{
	if (expressionTail.length == 0 || path.length == 0)
		return true;

	for (let j2=j; j2<path.length; j2++) 
		if (locationMatches(expressionTail,path.slice(j2)))
			return true;

	return false;
}

function expressionMatches(expr:string|number,pathElement:PathElement)
{
	const str = typeof expr == 'number' ? ''+expr : expr;

	const spaceIdx = str.indexOf(' ');

	if (spaceIdx === -1) {
		const [component,aClass] = str.split(':');
		const componentOk = component == pathElement.key || component == '*';
		const classOk = !aClass || (pathElement.classes ?? []).includes(aClass);
		return componentOk && classOk;
	}

	// Compound expression: 'component childKey', '* foreground', '*:class 0'
	const componentPart = str.substring(0, spaceIdx);
	const childKeyFilter = str.substring(spaceIdx + 1);

	const [component,aClass] = componentPart.split(':');
	const componentOk = component == pathElement.key || component == '*';
	const classOk = !aClass || (pathElement.classes ?? []).includes(aClass);
	const childKeyOk = childKeyFilter == '*' || childKeyFilter == String(pathElement.childKey);

	return componentOk && classOk && childKeyOk;
}

